import { render } from "./modalCrudComponent.vue?vue&type=template&id=3249ed3a"
import script from "./modalCrudComponent.vue?vue&type=script&lang=js"
export * from "./modalCrudComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__